// API Configuration
// This automatically uses the correct backend URL based on the environment
// - In development/preview: Uses REACT_APP_BACKEND_URL from .env
// - In production: Uses the same origin (window.location.origin)

const getApiBaseUrl = () => {
  // If we're in a browser and the hostname is NOT a preview/localhost URL,
  // use the current origin (production deployment)
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    
    // Check if this is a production deployment (custom domain, not preview)
    const isPreview = hostname.includes('preview.emergentagent.com') || 
                      hostname === 'localhost' || 
                      hostname === '127.0.0.1';
    
    if (!isPreview) {
      // Production: use same origin
      return window.location.origin;
    }
  }
  
  // Development/Preview: use env variable
  return process.env.REACT_APP_BACKEND_URL || '';
};

export const API_BASE_URL = getApiBaseUrl();
export const API_URL = `${API_BASE_URL}/api`;

export default API_URL;
